import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';
import { Form, Typography, VertButton, VertCheckbox, VertDatePicker, VertInput, notification } from '@vertem-core/vertice-ds';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import { pointsMask } from 'Utils/commons/points';
import { useDispatch, useSelector } from 'react-redux';
import MaskedInput from "components/Concierge/Components/MaskedInput";
import generateUUID from 'Utils/generateUUID';
import { validateBarCodeThunk } from 'redux/Reducers/Concierge/validateBarCodeSlicer';
import PaymentRulesBillModal from '../Modals/PaymentRulesBillModal';
import UserTermsModal from '../Modals/UserTermsModal';
import ConfirmDetailsPaymentModal from '../Modals/ConfirmDetailsPaymentModal';
import { getConvertedPriceThunk } from 'redux/Reducers/Concierge/getConvertedPriceSlice';
import { NumericFormat } from 'react-number-format';
import moment from 'moment';
import { SolicitationItemInitialState } from 'Constants/Concierge/initialStateValues';

const FormInformationBillPayment = ({ ...props }) => {

    const {
        solicitation,
        setSolicitation,
        userPoints,
        setShowForm,
        form,
        currentProductService,
        setCurrentProductService,
        isEditingProductService,
        setIsEditingProductService,
        editingProductServiceTotalPoints,
        subCategoryList,
        subCategorySelected,
    } = props;

    const [agreedTerms, setAgreedTerms] = useState(false);
    const [showModalRules, setShowModalRules] = useState(false);
    const [showModalUserTerms, setShowModalUSerTerms] = useState(false);
    const [showModalConfirmDetailsPayment, setShowModalConfirmDetailsPayment] = useState(false);
    const [confirmDetailsPayment, setConfirmDetailsPayment] = useState({});
    const [currMaskLength, setCurrMaskLength] = useState();

    const dispatch = useDispatch();

    const {
        dataValidateBarCode,
        loadingValidateBarCode,
        errorValidateBarCode,
    } = useSelector(
        (state) => state.ValidateBarCode
    );

    const Catalog = useSelector(({ Catalog: data }) => data);
    const { currencyConfiguration: { decimalPlaces, pointsName } } = Catalog;

    const sumTotalPointsValue = () => {
        return solicitation.productList?.filter(a => a.pointsValue)
            .map(a => (a.pointsValue))
            .reduce((total, number) => total + number, 0);
    }

    const remainingPoints = () => {
        var editedTotalPoints = parseInt(isEditingProductService ? editingProductServiceTotalPoints : "0");
        return (userPoints.pointsValue - sumTotalPointsValue()) + editedTotalPoints;
    }

    const resetForm = () => {

        form.resetFields();

        setCurrentProductService((prevState) => ({
            ...prevState,
            barCode: ""
        }));

        setCurrentProductService(SolicitationItemInitialState);
        setIsEditingProductService(false);
    }

    const calculateConvertedPrice = () => {
        const unitPrice = form.getFieldValue("unitValue");

        if (!unitPrice) return;

        const totalPrice = Number(unitPrice); 

        dispatch(getConvertedPriceThunk(totalPrice));
    }

    const validateValueEqualsZero = (unitValue) => {
        if (!unitValue) return Promise.reject();

        const errors = [];

        if (Number(unitValue) === 0) errors.push("Deve ser maior que 0.");

        if (errors.length > 0) return Promise.reject(errors);
        else return Promise.resolve();
    };

    const wrapperPoints = (points) => {
        return pointsMask(points, decimalPlaces, pointsName);
    }

    const customerBalance = wrapperPoints(userPoints.pointsValue);

    const handleBarCodeChange = (value) => {
        setCurrentProductService({
            ...currentProductService,
            barCode: value.replace(/\D/g, ''),
        });
    }

    const addBillPayment = (product) => {
        if (!product) return;

        if (!isEditingProductService) {
            product.id = generateUUID();

            if (solicitation.productList == undefined) solicitation.productList = [];

            setSolicitation((solicitation) => ({
                ...solicitation,
                productList: [...solicitation.productList, product]
            }))

            setShowForm(false);
            resetForm();
            return;
        }

        var newEditedProductList = solicitation.productList;
        solicitation.productList = [];
        newEditedProductList.map(productService => {
            setSolicitation((solicitation) => {
                if (productService.id == currentProductService.id)
                    return {
                        ...solicitation,
                        productList: [...solicitation.productList, product]
                    };

                return {
                    ...solicitation,
                    productList: [...solicitation.productList, productService]
                };
            }
            )
        }
        );

        setShowForm(false);
        resetForm();
    }

    const validateBarcode = (barcode) => {
        if (!barcode) return Promise.reject();

        const errors = [];

        if (currentProductService.barCode.length < currMaskLength)
            errors.push("Deve atingir o tamanho mínimo.");

        if (errors.length > 0) return Promise.reject(errors);
        else return Promise.resolve();
    }

    const validateTotalValue = (totalValue) => {
        if (!totalValue) return Promise.reject();

        const errors = [];

        if (Number(totalValue) > remainingPoints())
            errors.push(`Saldo ${pointsName} insuficiente.`);

        if (errors.length > 0) return Promise.reject(errors);
        else return Promise.resolve();  
    } 

    const handleAddBillPayment = () => {
        form.validateFields().then((product) => {
            product.subCategory = currentProductService.subCategory;
            product.subCategoryLabel = currentProductService.subCategoryLabel;
            product.pointsValue = product.pointsValue.replace(` ${pointsName}`, "");
            product.quantity = "1";
            product.isDueDateEditable = disabledFields.isDueDateEditable;
            product.isPriceEditable = disabledFields.isPriceEditable;
            setConfirmDetailsPayment({...product, agreedTerms});
            setShowModalConfirmDetailsPayment(true);
        }).catch(() => {    
            notification.error({
                message: "Preencha os campos corretamente."
            });
        });
    }

    const handleTermsAgreement = (agreedTerms) => {
        setAgreedTerms(agreedTerms);

        setCurrentProductService({
            ...currentProductService,
            agreedTerms,
        });
    }

    const convertMask = (inputMask) => {
        var mask = inputMask;
        if (!mask)
            return "";
        mask = mask.replace(/,/g, "");
        mask = mask.replace(/\\d/g, "9");
        return mask;
    }

    const maskLength = (inputMask) => {
        var mask = convertMask(inputMask);
        if (!mask)
            return 0;

        mask = mask.replace(/[^\w]/gi, "");
        return mask.length;
    }

    const minPaymentDate = (curr) => {
        const minDate = moment().subtract(1, 'days').endOf('day')
        return curr < minDate;
    }

    useEffect(() => {
        if (currentProductService.barCode.length == currMaskLength) {
            dispatch(validateBarCodeThunk({ barCode: currentProductService.barCode, serviceId: currentProductService.subCategory }));
        }
    }, [currentProductService.barCode]);

    const initialDisabledFields = {
        isPriceEditable: false,
        isDueDateEditable: false,
    };

    const [disabledFields, setDisabledFields] = useState(initialDisabledFields);

    useEffect(() => {
        if (!dataValidateBarCode) return;

        const { billValue, isPriceEditable, pointsValue, dueDate } = dataValidateBarCode;

        setDisabledFields({ ...disabledFields, isPriceEditable });
        setDisabledFields({ ...disabledFields, isDueDateEditable: dueDate ? false : true });

        setCurrentProductService((prevState) => ({
            ...prevState,
            date: dueDate,
            unitValue: billValue
        }));

        form.setFieldsValue(
            {
                date: dueDate,
                unitValue: `${billValue}`,
                pointsValue: `${pointsValue}`,
            }
        );

        form.validateFields([
            "date",
            "unitValue",
            "pointsValue",
        ]);
    }, [dataValidateBarCode]);

    useEffect(() => {
        if (!errorValidateBarCode) return;

        notification.error({
            message: errorValidateBarCode,
            duration: null,
        });
    }, [errorValidateBarCode]);

    useEffect(() => {
        if (currentProductService.barCode === '') {
            form.resetFields(["date", "unitValue", "pointsValue"]);

            setDisabledFields(initialDisabledFields);
        }
    }, [currentProductService]);

    useEffect(() => {
        if (isEditingProductService) return;
        if (!subCategorySelected) return;

        setCurrMaskLength(maskLength(subCategorySelected.mask));
    }, [subCategorySelected])

    useEffect(() => {
        if (!isEditingProductService) return;

        const { subCategory, barCode, date, unitValue, pointsValue, agreedTerms, isPriceEditable, isDueDateEditable } = currentProductService;

        const mask = subCategoryList.find(subItem => subItem.value == subCategory);
        setCurrMaskLength(maskLength(mask.subcategory.mask));

        setDisabledFields({
            isDueDateEditable,
            isPriceEditable,
        });

        form.setFieldsValue({
            barCode,
            date,
            unitValue,
            pointsValue,
        });

        if (agreedTerms) setAgreedTerms(agreedTerms);
    }, []);

    // value and onChange props are injected by <Form.Item />
    const CustomNumericInput = ({
        name,
        label,
        value,
        onChange,
        isPriceEditable,
    }) => {
        const [isFocused, setIsFocused] = useState(!!value);

        function handleChange({ value }) {
            onChange(value);
        }

        function handleBlur() {
            if (!value) setIsFocused(false);

            form.validateFields([name])
                .then(calculateConvertedPrice)
                .catch((err) => console.error(err));
        }

        return (
            <div className={`vert-input-container ${isFocused ? "focused" : ""}`}>
                <label className="vert-input-label">{label}</label>
                <NumericFormat
                    className={`${!isPriceEditable ? "field-disabled " : ""} ant-input ant-input-outlined vert-input vert-shape-default vert-template-marketplace ant-input-size-default padding-x-undefined`}
                    displayType={"input"}
                    value={value}
                    thousandSeparator="."
                    decimalSeparator=","
                    prefix="R$ "
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    isNumericString={true}
                    onFocus={() => setIsFocused(true)}
                    onValueChange={handleChange}
                    onBlur={handleBlur}
                    disabled={!isPriceEditable}
                />
            </div>
        );
    };

    return (
        <>

            <Row>
                <Col span={24} className='margin-top-small'>
                    <Typography.Text className='text-subtitle'>
                        Tipo de conta
                    </Typography.Text>
                </Col>

                <Col span={24} className='margin-top-small'>
                    <Typography.Text>
                        Você pode pagar contas de água, luz, telefone e gás, sendo permitido apenas um pagamento a cada 24 horas.
                    </Typography.Text>
                </Col>

                <Col span={24} className='margin-top-small'>
                    <VertButton
                        className='button-continue button-concierge'
                        type='default'
                        size="default"
                        onClick={() => {
                            setShowModalRules(true);
                        }}
                    >
                        Ler regras de pagamento
                    </VertButton>
                </Col>

                <Col span={24} className='margin-top-small'>
                    <Typography.Text className='text-subtitle'>
                        Informações do serviço
                    </Typography.Text>
                </Col>

                <Col span={24} className='margin-top-small'>
                    <Typography.Text>
                        O serviço de pagamento de contas é válido apenas para boletos com prazo de até 7 dias antes da data de vencimento. Se o prazo for superior a esse período, a solicitação não será enviada.
                    </Typography.Text>
                </Col>

                {
                    solicitation.isHierarchy &&
                        <Col span={24} className='margin-top-small'>
                            <Typography.Text className='font-weight-500'>
                                Saldo do cliente: {customerBalance.value} {customerBalance.label}
                            </Typography.Text>
                        </Col>
                }
            </Row>

            <Row gutter={[8, 8]} className='margin-top-small'>
                <Col span={24} className='margin-top-regular'>
                    <Form.Item
                        className='form-item-bar-code'
                        name="barCode"
                        validateTrigger={['onChange']}
                        rules={[
                            {
                                required: true,
                                message: 'Campo obrigatório.'
                            },
                            {
                                validator: (_, val) => validateBarcode(val),
                            }
                        ]}
                    >

                        <MaskedInput
                            name="barCode"
                            label="Código de barras"
                            mask={convertMask()}
                            form={form}
                            handleBarCodeChange={handleBarCodeChange}
                        />

                    </Form.Item>

                    <div className='container-bar-code-length'>
                        <span className='bar-code-length-span'>
                            {currentProductService.barCode?.length ?? 0}/{currMaskLength}
                        </span>
                    </div>

                </Col>

                <Col span={8}>
                    <Form.Item
                        name="date"
                        rules={[
                            {
                                required: true,
                                message: "Campo obrigatório.",
                            }
                        ]}
                    >
                        <VertDatePicker
                            placeholder={"Data de vencimento"}
                            picker="date"
                            format="DD/MM/YYYY"
                            placement="bottomLeft"
                            popupClassName='datepicker-delivery-popup'
                            className={`datepicker-deliver ${!disabledFields.isDueDateEditable ? "disabled-date" : ''}`}
                            disabledDate={minPaymentDate}
                            disabled={!disabledFields.isDueDateEditable}
                        />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        name="unitValue"
                        rules={[
                            {
                                required: true,
                                message: "Campo obrigatório.",
                            },
                            {
                                validator: (_, unitValue) => validateValueEqualsZero(unitValue)
                            }
                        ]}
                    >
                        <CustomNumericInput 
                            label="Valor do boleto"
                            isPriceEditable={disabledFields.isPriceEditable}
                        />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        name="pointsValue"
                        rules={[
                            {
                                required: true,
                                message: "Campo obrigatório.",
                            },
                            {
                                validator: (_, totalValue) => validateTotalValue(totalValue)
                            }
                        ]}
                    >
                        <VertInput
                            disabled
                            label={`Valor em ${pointsName}`}
                            className='field-disabled'
                        />
                    </Form.Item>
                </Col>

            </Row>

            <Row gutter={[8, 8]} className='margin-top-small'>

                <Col span={24}>
                    <Typography.Text className='text-subtitle'>
                        Antes de continuar você precisa aceitar os termos de uso
                    </Typography.Text>
                </Col>

                <Col span={24}>
                    <Form.Item
                        name="agreedTerms"
                        className='form-item-agreed-terms'
                    >
                        <VertCheckbox
                            onChange={(e) => handleTermsAgreement(e.target.checked)}
                            className='container-checkbox-budget'
                            checked={agreedTerms}
                        >
                            Li e aceito o <span className='link-user-terms' onClick={(event) => {
                                event.preventDefault();
                                setShowModalUSerTerms(true);
                            }}>Termo de uso</span>
                        </VertCheckbox>
                    </Form.Item>
                </Col>

            </Row>

            <Row gutter={[8, 8]} className='margin-top-small'>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>

                    {
                        (solicitation.productList?.length > 0) &&

                        <VertButton
                            type='default'
                            size="default"
                            htmlType="submit"
                            className='button-concierge'
                            onClick={() => {
                                resetForm();
                                setShowForm(false);
                            }}
                        >
                            <Typography.Text className='span-button'>
                                Cancelar
                            </Typography.Text>
                        </VertButton>
                    }

                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>

                    <Row justify={'end'} gutter={8}>

                        <Col>
                            <VertButton
                                type='default'
                                size="default"
                                className='margin-bottom-divider button-concierge'
                                htmlType="button"
                                onClick={
                                    () => {
                                        form.resetFields([
                                            'date',
                                            'barCode',
                                            'quantity',
                                            'description',
                                            'pointsValue',
                                            'unitValue',
                                            'agreedTerms'
                                        ]);
                                        setCurrentProductService((prevState) => ({
                                            ...prevState,
                                            description: '',
                                            barCode: ''
                                        }));
                                        setAgreedTerms(false);
                                    }
                                }
                            >
                                <Typography.Text className='span-button'>
                                    Limpar
                                </Typography.Text>
                            </VertButton>
                        </Col>
                        <Col>
                            <VertButton
                                className='button-continue button-concierge'
                                type='highlight'
                                size="default"
                                htmlType="button"
                                disabled={!agreedTerms || errorValidateBarCode}
                                loading={loadingValidateBarCode}
                                onClick={() => { handleAddBillPayment() }}
                            >
                                {isEditingProductService ?
                                    <Typography.Text className='span-button-continue'>
                                        Editar
                                    </Typography.Text> :
                                    <Typography.Text className='span-button-continue'>
                                        Adicionar
                                    </Typography.Text>
                                }
                            </VertButton>
                        </Col>
                    </Row>
                </Col>

            </Row>

            <PaymentRulesBillModal
                isOpen={showModalRules}
                onClose={() => {
                    setShowModalRules(false);
                }}
            />

            <UserTermsModal
                isOpen={showModalUserTerms}
                onClose={() => {
                    setShowModalUSerTerms(false);
                }}
            />

            <ConfirmDetailsPaymentModal
                isOpen={showModalConfirmDetailsPayment}
                onClose={() => {
                    setShowModalConfirmDetailsPayment(false);
                }}
                confirmDetailsPayment={confirmDetailsPayment}
                addBillPayment={value => addBillPayment(value)}
                form={form}
            />
        </>
    )
}

FormInformationBillPayment.propTypes = {
    solicitation: PropTypes.object.isRequired,
    setSolicitation: PropTypes.func.isRequired,
    setShowForm: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    currentProductService: PropTypes.object.isRequired,
    setCurrentProductService: PropTypes.func.isRequired,
    isEditingProductService: PropTypes.bool.isRequired,
    setIsEditingProductService: PropTypes.func.isRequired,
    editingProductServiceTotalPoints: PropTypes.number.isRequired,
    userPoints: PropTypes.number.isRequired,
    subCategorySelected: PropTypes.object.isRequired,
};

export default FormInformationBillPayment;